import { BoxProps } from '@jfs/ui-new'
import { shadowStyle } from './../../util/util'

const defaultStyles = {
  container: {
    alignItems: 'flex-start',
    marginBottom: 16,
    marginTop: 16,
    marginHorizontal: 16,
    width: 230,
  } as BoxProps,
  subTitleContainer: { marginTop: 5 } as BoxProps,
}

export const styles = {
  BOLD_TITLE: {
    ...defaultStyles,
  },
  BOLD_SUBTITLE: {
    ...defaultStyles,
  },
  READ_ONLY: {
    ...defaultStyles,
  },
  HORIZONTAL: {
    container: {
      flexDirection: 'row',
    } as BoxProps,
    subTitleContainer: {} as BoxProps,
  },
  HORIZONTAL_SUBTITLE: {
    container: {
      flexDirection: 'row',
    } as BoxProps,
    subTitleContainer: {} as BoxProps,
  },
  HORIZONTAL_BOLD: {
    container: {
      flexDirection: 'row',
    } as BoxProps,
    subTitleContainer: {} as BoxProps,
  },
  SETTLED: {
    container: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    } as BoxProps,
    subTitleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'TEXT_ERROR',
      borderBottomColor: 'BRAND_PRIMARY_RED',
      paddingLeft: 4,
      paddingRight: 4,
      borderBottomWidth: 1,
    } as BoxProps,
  },
  TO_BE_SETTLED: {
    container: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    } as BoxProps,
    subTitleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'GREEN',
      borderBottomColor: 'LEAF_GREEN',
      paddingLeft: 4,
      paddingRight: 4,
      borderBottomWidth: 1,
    } as BoxProps,
  },
  BOLD_TITLE_TRENDS: {
    container: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginRight: 16,
    } as BoxProps,
    subTitleContainer: { flexDirection: 'row', alignItems: 'center' } as BoxProps,
  },
  toolTipContainer: {
    maxWidth: 230,
    position: 'absolute',
    top: 0,
    ...shadowStyle,
    backgroundColor: 'WHITE',
    zIndex: 9999,
  } as BoxProps,
  toolTip: {
    marginLeft: 8,
  } as BoxProps,
}
